




















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import { trafficHourlyDistributions } from '@/modules/lcca/lib/trafficDsitributions';
import TrafficDistributionControl from '@/modules/lcca/views/components/TrafficDistributionControl.vue';


import * as d3 from 'd3-array';
import { createLccaValidations } from '@/modules/lcca/lib/validations';
import { getValidationMessages } from '@/lib/validation/validationMessages';
import { BaseProbVariables } from '@/modules/lcca/interfaces/probabilistic';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';

interface ITrafficDistributionEntry {
  value: number,
  hourStart: number,
  hourEnd: number
}


@Component({
  components: {
    TrafficDistributionControl,
    PxNumberInput,
    // InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class LccaTrafficDistribution extends Vue {
  @Prop() readonly pxLccaId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    return lccaStore.currentImperial;
  }

  validations() {
    return createLccaValidations(this.scenarioImperial);
  }

  sync() {
    if (this.trafficDistributionToModify) {
      this.scenario.trafficHourlyDistribution = this.trafficDistributionToModify.map(
        (t: ITrafficDistributionEntry) => Number(t.value),
      );
      lccaStore.setCurrentScenario(this.scenario);
    } else {
      console.warn('Scenario not synced.');
    }
  }

  save() {
    this.sync();
    lccaStore.saveCurrentScenario();
  }

  get trafficDistributionOptions() {
    return trafficHourlyDistributions.map((D) => ({ value: D.name, text: D.name }));
  }

  setTrafficDistributionToPreset() {
    const preset = trafficHourlyDistributions.filter((D) => D.name === this.scenario.patternType)[0];
    if (preset) {
      this.scenario.trafficHourlyDistribution = preset.data;
    }
    this.sync();
  }

  get trafficDistributionToModify() {
    if (this.scenario && this.scenario.trafficHourlyDistribution) {
      return this.scenario.trafficHourlyDistribution.map((t: number, i: number) => ({ value: t, hourStart: i, hourEnd: i + 1 }));
    } 
      console.error('Error parsing traffic from scenario');
  }

  get trafficDistTotal() {
    if (this.scenario && this.scenario.trafficHourlyDistribution) {
      return Number(d3.sum(this.scenario.trafficHourlyDistribution).toFixed(4));
    } 
      console.error('Error parsing traffic from scenario');
  }

  normalizeTrafficDistribution() {
    if (this.scenario && this.scenario.trafficHourlyDistribution) {
      const total = d3.sum(this.scenario.trafficHourlyDistribution);
      const normed = this.scenario.trafficHourlyDistribution.map((t: number) => Number((t / total).toFixed(6)));
      this.scenario.trafficHourlyDistribution = normed;
    } else {
      console.error('Error parsing traffic from scenario');
    }
  }

  get userProbInputs() {
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }


  get validationText(): string | null {
    // Show messages only when field is both invalid & dirty
    if (this.$v && this.$v.trafficDistTotal && this.$v.trafficDistTotal.$anyError) {
      return getValidationMessages(this.$v.trafficDistTotal);
    } 
      return null;
  }
}

